import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=72960058&scoped=true&"
import script from "./listItem.vue?vue&type=script&lang=js&"
export * from "./listItem.vue?vue&type=script&lang=js&"
import style0 from "./listItem.vue?vue&type=style&index=0&id=72960058&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72960058",
  null
  
)

export default component.exports